import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import './estrategiasIDI.scss'
import fotoColaboraciones from '../../../media/img/i+d+i/Colaboracion.jpg'
import fotoMetodologia from '../../../media/img/i+d+i/Metodologia.jpg'
import fotoEstrategicos from '../../../media/img/i+d+i/Estrategicos.jpg'
import crecimiento from '../../../media/img/i+d+i/crecimientogris.png'

const EstrategiasIDI = () => {
    const { t } = useTranslation();
    const lineRefs = useRef([]);

    useEffect(() => {
        const observerOptions = {
            threshold: 0.2,
            rootMargin: '0px 0px 0px 0px'
        };

        const lineObservers = lineRefs.current.map((lineRef) => {
            if (!lineRef) return null;

            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('content__title-line--visible');
                        observer.unobserve(entry.target);
                    }
                });
            }, observerOptions);

            observer.observe(lineRef);
            return observer;
        });

        return () => {
            lineObservers.forEach(obs => obs?.disconnect());
        };
    }, []);
    return (
        <div className='estrategiasIDI'>
            <section className='estrategiasIDI__container'>
                <div className='estrategiasIDI__header'>
                    <h1 className='estrategiasIDI__title '>{t('idi.strategies.title')}</h1>
                    <div ref={el => lineRefs.current[0] = el} className="content__title-line" />
                    <h2 className='estrategiasIDI__subtitle content__subtitle-backgroundDark'>
                        {t('idi.strategies.subtitle')}
                    </h2>
                    <p className='estrategiasIDI__text content__text-title-backgroundDark'>
                        {t('idi.strategies.description')}
                    </p>
                </div>
                <div className='estrategiasIDI__grid'>
                    <div className='estrategiasIDI__card '>
                        <div className='estrategiasIDI__grid-textcontainer'>
                            <h3 className='estrategiasIDI__grid-title'>{t('idi.strategies.actionTitle')}</h3>
                            <p className='estrategiasIDI__grid-descripcion'>
                                {t('idi.strategies.actionDesc')}
                            </p>
                            <ul className='estrategiasIDI__grid-list'>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.actionItem1')}</li>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.actionItem2')}</li>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.actionItem3')}</li>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.actionItem4')}</li>
                            </ul>
                        </div>

                        <div className='estrategiasIDI__grid-imagencontainer'>
                            <img className='estrategiasIDI__grid-imagen' src={fotoEstrategicos} alt={t('idi.strategies.actionTitle')} />
                        </div>
                    </div>
                    <div className='estrategiasIDI__card estrategiasIDI__card-flex-row-reverse'>
                        <div className='estrategiasIDI__grid-textcontainer'>
                            <h3 className='estrategiasIDI__grid-title'>{t('idi.strategies.methodTitle')}</h3>
                            <p className='estrategiasIDI__grid-descripcion'>
                                {t('idi.strategies.methodDesc')}
                            </p>
                            <ul className='estrategiasIDI__grid-list'>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.methodItem1')}</li>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.methodItem2')}</li>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.methodItem3')}</li>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.methodItem4')}</li>
                            </ul>
                        </div>

                        <div className='estrategiasIDI__grid-imagencontainer'>
                            <img className='estrategiasIDI__grid-imagen' src={fotoMetodologia} alt={t('idi.strategies.methodTitle')} />
                        </div>
                    </div>
                    <div className='estrategiasIDI__card '>
                        <div className='estrategiasIDI__grid-textcontainer'>
                            <h3 className='estrategiasIDI__grid-title'>{t('idi.strategies.partnerTitle')}</h3>
                            <p className='estrategiasIDI__grid-descripcion'>
                                {t('idi.strategies.partnerDesc')}
                            </p>
                            <ul className='estrategiasIDI__grid-list'>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.partnerItem1')}</li>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.partnerItem2')}</li>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.partnerItem3')}</li>
                                <li className='estrategiasIDI__grid-item'>{t('idi.strategies.partnerItem4')}</li>
                            </ul>
                        </div>

                        <div className='estrategiasIDI__grid-imagencontainer'>
                            <img className='estrategiasIDI__grid-imagen' src={fotoColaboraciones} alt={t('idi.strategies.partnerTitle')} />
                        </div>
                    </div>

                </div>
                <div className='estrategiasIDI__vision'>
                    <div className='estrategiasIDI__visioncontainers'>
                        <h1 className='estrategiasIDI__vision-title content__title-backgroundDark'>{t('idi.strategies.visionTitle')}</h1>
                        <div ref={el => lineRefs.current[1] = el} className="content__title-line" />
                        <h2 className='estrategiasIDI__vision-subtitle content__subtitle-backgroundDark'> {t('idi.strategies.visionSubtitle')}</h2></div>
                    <div className='estrategiasIDI__visioncontainers'>
                        <p className='estrategiasIDI__vision-text'>
                            {t('idi.strategies.visionText')}
                        </p>
                    </div>
                    <div className='estrategiasIDI__vision-imgContainer'>
                        <img className='estrategiasIDI__vision-img' src={crecimiento} alt="Crecimiento empresarial" />
                    </div>
                </div>
            </section>
        </div>
    )
}

export default EstrategiasIDI